import { render, staticRenderFns } from "./byPackingV2.vue?vue&type=template&id=7cbb4ab8&scoped=true&"
import script from "./byPackingV2.vue?vue&type=script&lang=js&"
export * from "./byPackingV2.vue?vue&type=script&lang=js&"
import style0 from "./byPackingV2.vue?vue&type=style&index=0&id=7cbb4ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbb4ab8",
  null
  
)

export default component.exports